<template>
  <div v-title="$route.meta.title">
    <div class="page-heading">
      <h3>
        {{$route.meta.title}}
      </h3>
      <el-breadcrumb separator-class="el-icon-arrow-right">
        <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
        <el-breadcrumb-item>签到反馈</el-breadcrumb-item>
        <el-breadcrumb-item>问题列表</el-breadcrumb-item>
      </el-breadcrumb>
    </div>

    <layout-panel :collapse="false">
      <template slot="header">搜索</template>
      <el-form :model="search"
               ref="searchForm"
               label-width="96px"
               label-position="right"
               size="medium"
               @submit.native.prevent="onSearch()">

        <div class="re-el-form__flex">
          <el-form-item label="工单ID"
                        prop="orderid">
            <el-input placeholder="请输入工单ID"
                      v-model="search.orderid"
                      clearable></el-input>
          </el-form-item>

          <el-form-item label="完成人"
                        prop="userid">
            <el-input placeholder="请输入完成人"
                      v-model="search.userid"
                      clearable></el-input>
          </el-form-item>

          <el-form-item label="任务标题"
                        prop="tasktitle">
            <el-input placeholder="请输入任务标题"
                      v-model="search.tasktitle"
                      clearable></el-input>
          </el-form-item>
          <el-form-item label="门店名称"
                        prop="marketname">
            <el-input placeholder="请输入门店名称"
                      v-model="search.market_name"
                      clearable></el-input>
          </el-form-item>
          <el-form-item label="提交时间"
                        prop="created_at">
            <el-date-picker
                v-model="search.created_at"
                value-format="yyyy-MM-dd HH:mm:ss"
                type="datetimerange"
                range-separator="至"
                start-placeholder="开始日期"
                end-placeholder="结束日期"
                align="center"
                class="width-max"
                clearable>
            </el-date-picker>
          </el-form-item>

          <el-form-item>
            <el-button type="primary"
                       icon="el-icon-search"
                       native-type="submit">搜索
            </el-button>
          </el-form-item>
        </div>
      </el-form>
    </layout-panel>

    <layout-panel :show-header="true">
      <template slot="header">列表</template>
      <template slot="tools">
        <el-button type="primary"
                   size="small"
                   icon="el-icon-refresh"
                   @click="onRefresh()"></el-button>
      </template>
      <el-table :data="table"
                stripe
                highlight-current-row
                border
                style="width: 100%">
        <el-table-column prop="orderid"
                         label="工单ID"
        ></el-table-column>
        <el-table-column prop="tasktitle"
                         label="任务标题"
        ></el-table-column>
        <el-table-column prop="userid"
                         label="完成人"
        ></el-table-column>
        <el-table-column prop="marketname"
                         label="门店名称"
        ></el-table-column>
        <el-table-column prop="detail"
                         label="问题描述"
        ></el-table-column>
        <el-table-column prop="created_at"
                         label="提交时间"
        ></el-table-column>
        <el-table-column prop="updated_at"
                         label="更新时间"
        ></el-table-column>
        <el-table-column fixed="right"
                        label="操作"
                        width="150">
        <template slot-scope="scope">
          <router-link :to="{ path: '/platform/sign-feedback-form?id='+scope.row.id }">
            <el-button type="text"
                        size="mini">更新门店
            </el-button>
          </router-link>
        </template>
        </el-table-column>
      </el-table>

      <div class="pagination">
        <el-pagination background
                       @size-change="handleSizePageChange"
                       @current-change="handleCurrentPageChange"
                       :current-page="pagination.current_page"
                       :page-sizes="[20, 50, 100, 200]"
                       :page-size="pagination.per_page"
                       layout="total, sizes, prev, pager, next, jumper"
                       :total="pagination.total">
        </el-pagination>
      </div>
    </layout-panel>
  </div>
</template>

<script>
import table from '@core/mixins/table'
import dateTimePicker from '@core/mixins/dateTimePicker'

export default {
  mixins: [table, dateTimePicker],

  data () {
    return {
      multipleSelection: [],
      table: [],
      search: {
        orderid: null,
        userid: null,
        marketname: null,
        tasktitle: null,
        created_at: [],
      },
      starLabels: [
        {
          value: 1,
          label: '题目繁杂'
        },
        {
          value: 2,
          label: '操作困难'
        },
        {
          value: 3,
          label: '还不错'
        },
        {
          value: 4,
          label: '感觉挺好'
        },
        {
          value: 5,
          label: '非常好'
        }
      ],
      exportHeader: [
        {
          key: 'id',
          text: 'ID'
        },
        {
          key: 'userid',
          text: '用户ID',
        },
        {
          key: 'tasktitle',
          text: '任务名称',
        },
        {
          key: 'orderid',
          text: '工单ID',
        },
        {
          key: 'created_at',
          text: '评价时间',
        },
        {
          key: 'content',
          text: '评价',
        },
        {
          key: 'star',
          text: '整体体验',
        },
      ],
    }
  },
  methods: {
    /**
     * 获得表格数据
     * @param {*} params
     */
    getTableData (params) {
      return request.page('getMarketInvalidFeedbackTable', params)
    },
    handleSelectionChange (val) {
      this.multipleSelection = val
    },
    formatStar (row, column, cellValue) {
      for (let i in this.starLabels) {
        if (this.starLabels.hasOwnProperty(i) && this.starLabels[i].value === cellValue * 1) {
          return this.starLabels[i].label
        }
      }
    },
  }
}
</script>



// WEBPACK FOOTER //
// src/views/platform/pages/SignFeedBackTable.vue